import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=e64eb800&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=e64eb800&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64eb800",
  null
  
)

export default component.exports